import React from 'react';
import Navigation from '../Navigation';
import Header from '../../../layouts/backend/Header';
import { Dashboard } from '../../../styles/layouts/header';

const PrivateLayout = ({ children }) => {
      return (
            <>
                  <Dashboard>
                        <Navigation />
                        <Header children={children} />
                  </Dashboard>
            </>
      );
};

export default PrivateLayout;
